import { ButtonPrimary } from "@/shared/components/atoms/ButtonPrimary";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { ModalSign } from "@/shared/components/organisms/ModalSign";
import { Select } from "@/shared/components/organisms/Select";
import { ToggleText } from "@/shared/components/organisms/ToggleText";


import { t } from "i18next";
import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

export type PersonalPageProps = any;

export const PersonalInformationPage = () => {
  const optionSex = [
    { id: 0, name: t("assisteds.controller.select_assisted") },
    { id: 1, name: t("user.views.male") },
    { id: 2, name: t("user.views.female") },
  ];
  const [selectSex, setSelectSex] = useState(optionSex[0]);
  //FIRTS CHECKED
  const [firstChecked, setFirstChecked] = useState(false);
  //SECOND CHECKED
  const [secondChecked, setSecondChecked] = useState(false);
  //THIRD CHECKED
  const [thirdChecked, setThirdChecked] = useState(false);
  //FOURTH CHECKED
  const [fourthChecked, setFourthChecked] = useState(false);
  //ACCEPT COMMUNICATIONS
  const [acceptCommunications, setAcceptCommunications] = useState(false);
  //IMAGE RIGTH
  const [imageRight, setImageRight] = useState(false);
  //OPEN MODAL SING
  const [openModalSign, setOpenModalSign] = useState(false);
  const handleOpenModalSign = () => setOpenModalSign(!openModalSign);
  //CANVAS PARA FIRMAR
  const sigCanvas = useRef(null);

  const clearSignature = () => {
    sigCanvas.current.clear();
  };
  return (
    <>
      <nav className="bg-white border-gray-200 px-4 py-2.5 rounded shadow-md">
        <div className="container flex flex-wrap items-center justify-between mx-auto">
          <div className="flex items-center">
            <img
              src="https://dash.fitmewise.com/uploads/branchs/default.png"
              className="h-20 mr-3"
              alt="Logo"
            />
            <span className="self-center text-xl font-semibold whitespace-normal text-gray-700">
              FILIAL 3 DEMON GYM
            </span>
          </div>
        </div>
      </nav>
      <div className="mx-0 sm:mx-auto w-full sm:w-3/4 h-full px-4 sm:px-0">
        <div className="mt-6 pb-10">
          <div className="space-y-4">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.general_info")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <Select
                    selected={selectSex}
                    setSelected={setSelectSex}
                    options={optionSex}
                    tittle={t("user.views.sex")}
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.birthday")}
                    type="date"
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.phone")}
                    type="tel"
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.occupation")}
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.cuestion_health")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.question_1")}
                    </h2>
                    <ToggleText
                      texto={firstChecked ? t("general.yes") : t("general.no")}
                      checked={firstChecked}
                      onChange={() => setFirstChecked(!firstChecked)}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.question_2")}
                    </h2>
                    <ToggleText
                      texto={secondChecked ? t("general.yes") : t("general.no")}
                      checked={secondChecked}
                      onChange={() => setSecondChecked(!secondChecked)}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.question_3")}
                    </h2>
                    <ToggleText
                      texto={thirdChecked ? t("general.yes") : t("general.no")}
                      checked={thirdChecked}
                      onChange={() => setThirdChecked(!thirdChecked)}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.question_4")}
                    </h2>
                    <ToggleText
                      texto={fourthChecked ? t("general.yes") : t("general.no")}
                      checked={fourthChecked}
                      onChange={() => setFourthChecked(!fourthChecked)}
                    />
                  </div>
                </div>
              </div>
              {firstChecked === true ||
              secondChecked === true ||
              thirdChecked === true ||
              fourthChecked === true ? (
                <h1 className="text-base font-semibold leading-7 text-gray-900 text-center col-span-full">
                  {t("user.views.form_gym_text")}
                </h1>
              ) : (
                <></>
              )}
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.clauseles")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="flex items-center justify-between">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.accept_clauses_norms")}
                    </h2>
                    <ToggleText
                      texto={t("general.yes")}
                      checked={true}
                      onChange={() => {}}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.informed_participation")}
                    </h2>
                    <ToggleText
                      texto={t("general.yes")}
                      checked={true}
                      onChange={() => {}}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.accept_commercial_communications")}
                    </h2>
                    <ToggleText
                      texto={
                        acceptCommunications
                          ? t("general.yes")
                          : t("general.no")
                      }
                      checked={acceptCommunications}
                      onChange={() =>
                        setAcceptCommunications(!acceptCommunications)
                      }
                    />
                  </div>
                </div>
                <div className="col-span-full">
                  <div className="flex items-center justify-between gap-4">
                    <h2 className="text-base leading-7 text-gray-900">
                      {t("user.views.image_rights_consent")}
                    </h2>
                    <ToggleText
                      texto={imageRight ? t("general.yes") : t("general.no")}
                      checked={imageRight}
                      onChange={() => setImageRight(!imageRight)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <h2 className="text-base font-semibold leading-7 text-gray-900 text-center">
              {t("user.views.contract_accept")}
            </h2>
            <div className="flex items-center justify-center">
              <ButtonSoft
                text={t("subscription.views.signature_text")}
                size="extraLarge"
                onClick={handleOpenModalSign}
              />
            </div>
            <div className="flex items-center justify-center">
              <ButtonPrimary text={t("chat.app.send")} size="large" />
            </div>
          </div>
        </div>
      </div>
      <ModalSign
        onClick={() => {}}
        onClose={handleOpenModalSign}
        open={openModalSign}
        acceptButtonText={t("subscription.views.save_signature")}
        cancelButtonText={t("general.cancel")}
        title={t("subscription.views.sign_contract")}
        button={<ButtonSoft text={t("user.views.see_contract")} size="large" />}
        onClean={clearSignature}
      >
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          canvasProps={{
            width: 400,
            height: 150,
            className: "sigCanvas border border-gray-200 rounded",
          }}
        />
      </ModalSign>
    </>
  );
};
